const Footer = () => {
  return <footer className="z-10" style={{ background: '#041E42', height: 33, width: '100%', position: 'fixed', bottom: 0, textAlign: 'center', padding: 7 }}>
    <span style={{ fontSize: '10px', color: '#fff' }}>© 2026 JB360</span>
  </footer>
}

export default Footer;